import { DatePipe, AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { DayAgoPipe } from '@fitness-force/shared-utils';
import { TooltipModule } from 'primeng/tooltip';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'date-cell',
  templateUrl: './date-cell.component.html',
  styleUrls: ['./date-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DayAgoPipe, TooltipModule, AsyncPipe],
})
export class DateCellComponent {
  private datePipe = inject(DatePipe);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  isEmptyAndNull(obj: any) {
    if (!obj) return true;
    else if (Object.keys(obj).length === 0) {
      return true;
    } else return false;
  }

  showDate(date: any) {
    return this.datePipe.transform(new Date(date), 'MMM dd yyyy hh:mm:ss a');
  }

  hasValue(obj: any) {
    if (obj != null && obj != undefined) return true;
    else return false;
  }

  isvalidDate(date: any) {
    if (date === null || date === undefined || date === '') {
      return false;
    }
    return !isNaN(new Date(date).getTime());
  }
}
